import { httpClient } from '@/lib/api';
import { accountApi, type AccountProfile } from '@/features/account/account.api';
import type { AccountAppearance, AvatarCatalog, AvatarDesign } from './avatar';
const root = accountApi.isConsultant ? '/consultant-auth/account' : '/auth/account';
export const appearanceApi = {
  read: (): Promise<AccountAppearance> => httpClient.get(`${root}/appearance`),
  catalog: (): Promise<AvatarCatalog> => httpClient.get(`${root}/avatar-catalog`),
  save: (design: AvatarDesign, version: number): Promise<AccountProfile> =>
    httpClient.put(`${root}/avatar`, { design, version }),
  photo: (blob: Blob, version: number): Promise<AccountAppearance> => {
    const body = new FormData();
    body.append('image', blob, 'portrait.jpg');
    body.append('version', String(version));
    return httpClient.post(`${root}/photo`, body, { timeoutMs: 60000 });
  },
  removePhoto: (version: number): Promise<AccountAppearance> =>
    httpClient.delete(`${root}/photo`, { body: { version } }),
};
